<template>
  <div data-cy="meter" class="meter-read">
    <div class="meter-read__title">
      {{ title }}
    </div>
    <div data-cy="meter-value" class="meter-read__value">
      <Wattage :value="animatedValue" :type="valueType" />
    </div>
    <div class="meter-read__arrows">
      <ConsumptionArrow
        type="positive"
        :angle="communityArrowAngle"
        :disabled="communityArrowDisabled"
      />
      <ConsumptionArrow
        :type="supplierArrowType"
        :angle="supplierArrowAngle"
        :disabled="supplierArrowDisabled"
      />
    </div>
  </div>
</template>

<script>
  import ConsumptionArrow from '@/components/icons/ConsumptionArrow.vue'
  import Wattage from '@/components/Wattage.vue'
  import TweenLite from 'gsap'
  import { WATTAGE_TWEEN_DURATION } from '@/constants.ts'
  import { useStrings } from '@/composables/useStrings.ts'
  import { useCurrentReadsStore } from '@/stores/useCurrentReadsStore'
  import { useCubeStore } from '@/stores/useCubeStore'

  export default {
    name: 'meter-read',
    components: {
      ConsumptionArrow,
      Wattage,
    },
    setup() {
        const cubeStore = useCubeStore()
        const currentReadsStore = useCurrentReadsStore()
        const { t } = useStrings()
        return {
          t,
          cubeStore,
          currentReadsStore,
        }
    },
    data() {
      return {
        animatedValue: 0,
      }
    },
    mounted() {
      this.animatedValue = this.currentReadsStore.currentRead
    },
    computed: {
      title: function () {
        if (this.currentReadsStore.currentReadIsConsumption) {
          if (this.cubeStore.meterType === 'Meterless') {
            return (
              this.t('home.consumption') +
              ' ' +
              this.t('home.prognosisValue')
            )
          }
          return this.t('home.consumption')
        }
        else {
          if (this.cubeStore.meterType === 'Meterless') {
            return (
              this.t('home.production') +
              ' ' +
              this.t('home.prognosisValue')
            )
          }
          return this.t('home.production')
        }
      },
      value: function () {
        return this.currentReadsStore.currentRead
      },
      valueType: function () {
        const reads = this.currentReadsStore
        if (reads.toCommunity > 0 || reads.toSupplier > 0) {
          return 'positive'
        } else {
          return 'negative'
        }
      },
      communityArrowAngle: function () {
        return this.currentReadsStore.toCommunity ? 180 : 0
      },
      communityArrowDisabled: function () {
        return this.currentReadsStore.toCommunity === 0 && this.currentReadsStore.fromCommunity === 0
      },
      supplierArrowAngle: function () {
        return this.currentReadsStore.toSupplier ? 180 : 0
      },
      supplierArrowDisabled: function () {
        return this.currentReadsStore.toSupplier === 0 && this.currentReadsStore.fromSupplier === 0
      },
      supplierArrowType: function () {
        return this.currentReadsStore.toSupplier > 0 ? 'positive' : 'negative'
      },
    },
    watch: {
      value: function (newValue) {
        TweenLite.to(this.$data, WATTAGE_TWEEN_DURATION, {
          animatedValue: newValue,
        })
      },
    },
  }
</script>

<style lang="scss">
  .meter-read {
    text-align: center;
    transition: $transition-base;

    @media (min-width: 360px) {
      //margin-top: 1vh;
    }

    @media (min-height: 600px) {
      margin-top: 2vh;

      @media (min-width: 360px) {
        margin-top: 1vh;
      }
    }

    @media (min-height: 600px) {
      @media (min-width: 360px) {
        margin-bottom: 2vh;
      }
    }

    @media (min-height: 700px) {
      margin-bottom: 0;
    }

    @media (min-height: 800px) {
      margin-top: 2vh;
      margin-bottom: 2vh;
    }

    &__title {
      line-height: $line-height-sm;
      font-size: $font-size-sm;

      @media (min-width: $bp-xs) {
        font-size: $font-size-base;
      }
    }

    &__value {
      line-height: $line-height-sm;
      font-size: $wattage-font-size-min;
    }
  }
</style>
